import {red} from "@mui/material/colors";

export const gmtpTheme = {
    palette: {
        primary: red,
    },
}
